import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const PlayOsmerosmerkaView = () => import('../views/PlayOsmerosmerkaView.vue')
const PlayStevilcnaOsmerosmerkaView = () => import('../views/PlayStevilcnaOsmerosmerkaView.vue')

const routes: Array<RouteRecordRaw> = [
  // Spremenjeno: Preusmeritev na /play brez ID-ja (začetni zaslon)
  { path: '/', redirect: '/play' },

  {
    // Spremenjeno: Dodan vprašaj (:id?), kar pomeni, da je ID neobvezen
    path: '/play/:id?',
    name: 'PlayGame',
    component: PlayOsmerosmerkaView,
  },

  // Odstranjena preusmeritev za /play-st, združeno spodaj:
  {
    // Spremenjeno: Tudi tukaj je ID neobvezen
    path: '/play-st/:id?',
    name: 'PlayStevilcnaOsmerosmerka',
    component: PlayStevilcnaOsmerosmerkaView,
  },

  // Spodnje poti za "Scheduled" igre ostanejo enake (identifier je obvezen)
  {
    path: '/sch/osmerosmerka/:identifier',
    name: 'ScheduledClassicPlayer',
    component: PlayOsmerosmerkaView,
  },
  {
    path: '/sch/st-osmerosmerka/:identifier',
    name: 'ScheduledNumericPlayer',
    component: PlayStevilcnaOsmerosmerkaView,
  },

  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

export default router
